import { RequestedScope } from '../../services/api';

export const hasRequestedSearchScope = (scope: RequestedScope): boolean => (
  scope.index_ids.length > 0 || scope.prompt_run_ids.length > 0
);

export const hasSelectedSearchScope = (
  selectedIndexes: string[] | null,
  selectedRunIds: string[] | null,
): boolean => hasRequestedSearchScope({
  index_ids: selectedIndexes || [],
  prompt_run_ids: selectedRunIds || [],
});
